import { Fragment } from "react";
import {
  GridItem,
  SimpleGrid,
  Skeleton,
  useBreakpointValue,
} from "@chakra-ui/react";
import ProfileCard, {
  ProfileCardHeader,
} from "components/profile/profile-card";
import VirtualizedTableLogoAndName from "components/virtualized-table/virtualized-table-logo-and-name";
import type { CompanySubsidiary } from "types/api/company/details/overview";

interface SubsidiariesCardProps {
  isLoaded: boolean;
  subsidiaries: CompanySubsidiary[];
}

const SubsidiariesCard = ({
  isLoaded = false,
  subsidiaries = [],
}: SubsidiariesCardProps) => {
  const columns = useBreakpointValue([1, 2]);

  const data = isLoaded ? subsidiaries : Array((columns || 2) * 5).fill("");

  if (!data?.length) {
    return null;
  }

  return (
    <ProfileCard overflow="hidden">
      <ProfileCardHeader>Subsidiaries</ProfileCardHeader>

      <SimpleGrid
        columns={columns}
        maxH="285px"
        overflowY="auto"
        columnGap={4}
        rowGap={2}
        m={-4}
        p={4}
      >
        {data.map((subsidiary, i) => (
          <Fragment key={subsidiary.id || i}>
            <GridItem key={subsidiary.id} fontSize="sm">
              {isLoaded ? (
                <VirtualizedTableLogoAndName
                  name={subsidiary.name}
                  logo={subsidiary.logo}
                  url={subsidiary.urlSlug}
                />
              ) : (
                <Skeleton h="25px" />
              )}
            </GridItem>

            {((i + 1) % columns === 0 || i === subsidiaries.length - 1) && (
              <GridItem
                colSpan={columns}
                borderTopWidth="1px"
                mx={-4}
                pb={i === subsidiaries.length - 1 ? 2 : 0}
              />
            )}
          </Fragment>
        ))}
      </SimpleGrid>
    </ProfileCard>
  );
};

export default SubsidiariesCard;
